module.exports = __webpack_public_path__ + "static/media/Roadmap-subHeader-Yellow.4523a287.png";